export default __webpack_public_path__ + "static/media/garbageWhite.c3ffe289.svg";